// "Back to top" button (see back-to-top.php): slides in once the footer is in
// the viewport - the same moment the product bar steps aside, so the two hand
// over - but never on the first screen, so pages shorter than two screens
// never show it. Hides again on the way back up, and scrolls the page to the
// top on click.

const FOOTER = '[data-elementor-type="footer"]';

function bindBackToTop(button) {
    if (button.dataset.sonToTopReady) {
        return;
    }
    button.dataset.sonToTopReady = 'true';

    const footer = document.querySelector(button.dataset.sonToTopWatch || FOOTER);
    if (!footer) {
        return;
    }

    let footerVisible = false;

    const update = () => {
        const pastFirstScreen = window.scrollY >= window.innerHeight;

        button.classList.toggle('is-visible', footerVisible && pastFirstScreen);
    };

    new IntersectionObserver(
        (entries) => {
            footerVisible = entries[entries.length - 1].isIntersecting;
            update();
        }
    ).observe(footer);

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    button.addEventListener('click', () => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.son-to-top').forEach(bindBackToTop);
});
